import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const MIRAMARGRAVITYSEWER_LAYER_ID = 'miramarGravitySewerLayer';

const layerConfig = {
  title: 'Gravity Sewer',
};

function MiramarGravitySewerLayer() {
  const dispatch = useDispatch();
  const { miramarGravitySewerLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarGravitySewerLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarGravitySewerLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARGRAVITYSEWER_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarGravitySewerLayer.visible,
      opacity: miramarGravitySewerLayer.opacity,

      getLineColor: [199, 126, 52],
      lineWidthMinPixels: 2,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARGRAVITYSEWER_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['Sewer_Subtype', 'Sewer_Material', 'Pipe_Diameter_Inch'],
            }),
          };
        }
      },
    });
  }
}

export default MiramarGravitySewerLayer;
